import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { MyOrdersInsurance } from 'shared/api/avia/insurance'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { InsuranceInfoCard } from './components/insurance-info-card'
import s from './styles.module.scss'

interface Props {
  insurances: MyOrdersInsurance[]
}

export const InsuranceInfo = ({ insurances }: Props) => {
  const { t } = useTranslation()
  const [dropped, setDropped] = useState(false)

  if (!insurances.length) {
    return
  }
  return (
    <div className={s.container}>
      <div
        className={s.flexxer}
        onClick={() => setDropped(!dropped)}
      >
        <p className="semi-bold-17">{t('insurance_info.insurance')}</p>

        <AppIcon
          id={AllIcons.ARROW_RIGHT}
          className={clsx(s.arrow, dropped && s.arrowDropped)}
        />
      </div>

      {dropped && (
        <div className={s.insuranceList}>
          {insurances.map((insurance) => (
            <InsuranceInfoCard insurance={insurance} />
          ))}
        </div>
      )}
    </div>
  )
}
